/**
 * Asyncronously loads script.
 *
 * @param id - script tag id (to not load script twice)
 * @param src - script src
 * @param skipCorsChecks - true if we don't need CORS checks on client (some script origins doesn't support them)
 * @returns promise that is resolved once script is loaded
 */
export const loadScript = (id: string, src: string, skipCorsChecks: boolean = false): Promise<void> => {
    if (document.getElementById(id)) return Promise.resolve();

    return new Promise((resolve, reject) => {
        const script = document.createElement('script');

        script.id = id;
        if (!skipCorsChecks) {
            script.crossOrigin = 'anonymous';
        }
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load external script: ${id}`));
        script.src = src;

        document.body.appendChild(script);
    });
};
